import {
    IonPage, IonContent, IonInput, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';
import {addressInit} from "../../../../utils/address";
import {getQueryVariable, isPhoneNumber} from "../../../../utils/commonFunction";
import {getPcGameList, getPhoneGameList, submitLoginEx, submitPropEx} from "./Service";
import {uploadImage} from "../../../../utils/uploadPic";
import cookieUtil from "../../../../utils/cookieUtil";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";
import Script from "react-load-script";
import moment from "moment/moment";
import 'moment/locale/zh-cn';

moment.locale('zh-cn');


class GameException extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            showNoticeTip: false,
            account: '',
            inRoomShowGold: '',
            gamingShowGold: '',
            outRoomShowGold: '',
            stolenGold: '',
            abnormalTime: '',
            inRoomTime: '',
            abnormalGameId: 0,
            platform: 0,
            abnormalRoomName: '',
            content: '',
            gameList: [],
            isShow: false,
            files: [],
            selectedImages: [],
            realImageUrls: [],
            step: 1,
            isPicUpload: false,
            isPropEx: false,
            loginOs: '',
            loginNetwork: '',
            phoneModels: '',
            otherNetwork: '',
            seachprov: '',
            seachcity: '',
            seachdistrict: '',
            token: null,
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }

    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        console.log('phoneTip====' + phoneTip)
        this.setState({
            phoneTip: phoneTip,
        })

    };

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }
        if (cookieUtil.has("userInfo")) {
            let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
            this.setState({account: userInfoJson.userGameId})
        }
        // 兼容公众号个人中心--登录或道具异常跳转至该页面
        let userGameId = getQueryVariable('userGameId');
        if (userGameId !== null && userGameId !== '' && userGameId !== '0') {
            this.setState({account: userGameId})
        }
        let isPropExPm = getQueryVariable('isPropEx');
        if (isPropExPm !== null && isPropExPm !== '' && isPropExPm === '1') {
            this.setState({isPropEx: true})
        }
        this.getGameList('0');
        addressInit('seachprov', 'seachcity', 'seachdistrict');
    }

    getGameList = (e) => {
        this.setState({platform: e})

        //获取pc游戏列表
        if (e === '0') {
            const param = {}
            getPcGameList(param).then(res => {
                if (res.code === '10000') {
                    this.setState({
                        gameList: res.data,
                        abnormalGameId: res.data[0].kindId
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        }
        //获取手机游戏列表
        else if (e === '1') {
            const param = {}
            getPhoneGameList(param).then(res => {
                console.log(res);
                if (res.code === '10000') {
                    console.log(res.data)
                    this.setState({
                        gameList: res.data,
                        abnormalGameId: res.data[0].kindId
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }


    showNotice = () => {
        const {showNoticeTip} = this.state;
        this.setState({
            showNoticeTip: !showNoticeTip
        })
    }

    setAbnormalTime = (moment) => {
        if (moment._isAMomentObject) {
            const selectedDate = moment.format('YYYY-MM-DD');
            const selectedTime = moment.format('HH:mm:ss');
            const selectedDateTime = selectedDate + ' ' + selectedTime;
            this.setState({abnormalTime: selectedDateTime})
        } else if (moment.length > 0) {
            this.setState({abnormalTime: moment})
        }
    }


    validateTimeFormat = () => {
        const {abnormalTime} = this.state;
        if (abnormalTime && !this.validateDateTimeFormat(abnormalTime)) {
            this.setState({isShowTip: true, showTipMsg: '出现异常的时间格式不正确，请重新选择'})
            return;
        }

    }

    validateDateTimeFormat = (dateTimeString) => {
        const dateTimeFormat = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/;
        return dateTimeFormat.test(dateTimeString);
    }


    nextStep = () => {

        const {
            step,
            inRoomShowGold,
            gamingShowGold,
            outRoomShowGold,
            stolenGold,
            account,
            loginOs,
            loginNetwork,
            abnormalRoomName,
            abnormalTime,
            phone,
            isPropEx
        } = this.state;

        if (account === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的账号/游戏ID'})
            return;
        }

        if (abnormalRoomName === '') {
            this.setState({isShowTip: true, showTipMsg: '请填写异常房间名！'})
            return;
        }

        if (phone.length > 0 && !isPhoneNumber(phone)) {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的手机号码！'})
            return;
        }

        if (abnormalTime === '' || !this.validateDateTimeFormat(abnormalTime)) {
            this.setState({isShowTip: true, showTipMsg: '请输入游戏异常时间！'})
            return;
        }

        if (isPropEx) {
            if (inRoomShowGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入进房间携带金币数！'})
                return;
            }
            if (isNaN(inRoomShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '进房间携带金币数请输入数字！'})
                return;
            }

            if (gamingShowGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入游戏中显示金币数！'})
                return;
            }
            if (isNaN(gamingShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '游戏中显示金币数请输入数字！'})
                return;
            }

            if (outRoomShowGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入出房间显示金币数！'})
                return;
            }
            if (isNaN(outRoomShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '出房间显示金币数请输入数字！'})
                return;
            }

            if (stolenGold === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入实际结算异常金币数！'})
                return;
            }
            if (isNaN(stolenGold)) {
                this.setState({isShowTip: true, showTipMsg: '实际结算异常金币数输入数字！'})
                return;
            }
        }
        this.setState({step: 2});

    }


    submitMsg = () => {

        const {
            account,
            inRoomShowGold,
            gamingShowGold,
            outRoomShowGold,
            stolenGold,
            abnormalTime,
            content,
            phone,
            abnormalRoomName,
            inRoomTime,
            abnormalGameId,
            platform,
            realImageUrls,
            isPropEx,
            loginGameId,
            loginNetwork,
            loginArea,
            loginOs,
            phoneModels,
            otherNetwork,
        } = this.state;

        this.validateTimeFormat();

        if (account === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的账号/游戏ID'})
            return;
        }

        if (abnormalRoomName === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入异常的房间名'})
            return;
        }

        if (phone.length > 0 && !isPhoneNumber(phone)) {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的手机号码！'})
            return;
        }
        let oftenLoginArea = '';

        if (isPropEx) {
            if (inRoomShowGold === '' || isNaN(inRoomShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '请输入正确的房间展示金币'})
                return;
            }

            if (gamingShowGold === '' || isNaN(gamingShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '请输入正确的房间内展示金币数'})
                return;
            }

            if (outRoomShowGold === '' || isNaN(outRoomShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '请输入正确的出房间显示金币数'})
                return;
            }

            if (stolenGold === '' || isNaN(outRoomShowGold)) {
                this.setState({isShowTip: true, showTipMsg: '请输入正确的 实际结算异常金币数'})
                return;
            }

        } else {
            const seachprovValue = document.getElementById('seachprov').value;
            const seachcityValue = document.getElementById('seachcity').value;
            const seachdistrictValue = document.getElementById('seachdistrict').value;
            oftenLoginArea = seachprovValue + seachcityValue + seachdistrictValue;


            if (oftenLoginArea === '' || oftenLoginArea === 'null') {
                this.setState({isShowTip: true, showTipMsg: '请选择常登录的地区！'})
                return;
            }

            if (loginOs === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入操作系统！'})
                return;
            }
            if (loginNetwork === '') {
                this.setState({isShowTip: true, showTipMsg: '请输入网络使用情况！'})
                return;
            }

            if (content === '' || content.length < 10) {
                this.setState({isShowTip: true, showTipMsg: '请输入游戏异常说明,至少输入10个汉字'})
                return;
            }

        }

        //处理图片
        let picUrls = '';
        if (realImageUrls.length > 0) {
            for (let i = 0; i < realImageUrls.length; i++) {
                if (i === 0) {
                    picUrls = realImageUrls[i]
                } else {
                    picUrls = picUrls + ";" + realImageUrls[i]
                }
            }
        }
        const _that = this;

        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {

            if (res.ret === 0) {
                if (isPropEx) {
                    const params = {
                        'inRoomShowGold': inRoomShowGold,
                        'gamingShowGold': gamingShowGold,
                        'outRoomShowGold': outRoomShowGold,
                        'stolenGold': stolenGold,
                        'abnormalTime': abnormalTime,
                        'inRoomTime': inRoomTime,
                        'platform': platform,
                        'abnormalGameId': abnormalGameId,
                        'abnormalRoomName': abnormalRoomName,
                        'picUrls': picUrls,
                        'phone': phone,
                        'content': content,
                        'accounts': account,
                        'ticket': res.ticket,
                        'randStr': res.randstr,
                    }
                    console.log(params)
                    submitPropEx(params).then(ret => {
                        if (ret.code === '10000') {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: "提交成功，请耐心等待我们处理。"
                            })
                        } else {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                        captcha1.destroy();
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                } else {
                    const params = {
                        'abnormalTime': abnormalTime,
                        'loginArea': oftenLoginArea,
                        'loginOs': loginOs,
                        'phoneModels': phoneModels,
                        'loginNetwork': loginNetwork,
                        'otherNetwork': otherNetwork,
                        'platform': platform,
                        'loginGameId': loginGameId,
                        'roomName': abnormalRoomName,
                        'picUrls': picUrls,
                        'phone': phone,
                        'content': content,
                        'accounts': account,
                        'ticket': res.ticket,
                        'randStr': res.randstr,
                    }
                    console.log(params)
                    submitLoginEx(params).then(ret => {
                        if (ret.code === '10000') {
                            console.log(ret.data);
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: "提交成功，请耐心等待我们处理。"
                            })
                        } else {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                        captcha1.destroy();
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码
    }


    /**
     * 图片上传
     * @param type  1充值截图 2监护人户口页 3未成年户口页 4出生或监护证明 5举证材料
     * @param event
     * @returns {Promise<void>}
     */
    handleFileInputChange = async (type, event) => {
        const {
            selectedImages,
            realImageUrls,
        } = this.state;

        const fileList = event.target.files;
        //console.log(fileList);
        let images = [];
        switch (type) {
            case 1:
                if (selectedImages.length + fileList.length > 5) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传5张图片,请重新选择！'})
                    return;
                }
                images = selectedImages;
                break;
        }

        let isJpgOrPng = true;
        let isLt2M = true;
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            //console.log(file)
            isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.setState({isShowTip: true, showTipMsg: '只能上传JPG/PNG格式的图片'})
                return;
            }
            isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.setState({isShowTip: true, showTipMsg: '上传图片不能大于10MB'})
                return;
            }
        }

        let realUrls = [];

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const reader = new FileReader();
            const params = {
                file: file,
                path: 'pc/accountRefund'
            }
            const imageUrl = await uploadImage(params);
            if (imageUrl === "" || imageUrl === null) {
                this.setState({isShowTip: true, showTipMsg: '图片上传失败'})
                return;
            }
            realUrls = imageUrl
            if (type === 1) {
                realImageUrls.push(imageUrl);
                realUrls = realImageUrls;
            }

            reader.onload = (event) => {
                images.push(event.target.result);
                if (i === fileList.length - 1) {
                    switch (type) {
                        case 1:
                            this.setState({selectedImages: images, realImageUrls: realUrls})
                            break;
                    }
                }
            };
            await reader.readAsDataURL(file);
        }
    }

    /**
     * 上图图片按钮触发
     * @param idx
     */
    uploadBtnLoad = (idx) => {
        const uploadInput = document.getElementById('upload_' + idx);
        uploadInput.click();
    }

    /**
     * 删除图片
     * @param index
     */
    handleImageDelete = (index, type) => {
        const {
            selectedImages,
            realImageUrls,
        } = this.state;

        let images = [];
        let realImages = [];

        images = [...selectedImages];
        realImages = [...realImageUrls];
        images.splice(index, 1);
        realImages.splice(index, 1);
        this.setState({selectedImages: images, realImageUrls: realImages})

    };

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }


    /**
     * 图片上传页面展示
     * @param type
     */
    uploadPage = (type) => {

        const seachprovValue = document.getElementById('seachprov').value;
        const seachcityValue = document.getElementById('seachcity').value;
        const seachdistrictValue = document.getElementById('seachdistrict').value;

        this.setState({
            seachprov: seachprovValue,
            seachcity: seachcityValue,
            seachdistrict: seachdistrictValue,
            isPicUpload: true,
            picType: type
        })
    }

    returnPage = () => {
        setTimeout(function () {
            addressInit('seachprov', 'seachcity', 'seachdistrict');
        }, 300);
        this.setState({isPicUpload: false})

    }

    setLoginOs = () => {
        //获取 操作系统 loginOs
        const loginOsCheckBoxs = document.getElementsByName('loginOs');
        let loginOs = '';
        for (let i = 0; i < loginOsCheckBoxs.length; i++) {
            if (loginOsCheckBoxs[i].checked) {
                if (loginOs.length === 0) {
                    loginOs = loginOsCheckBoxs[i].value;
                    continue;
                }
                loginOs = loginOs + "," + loginOsCheckBoxs[i].value;
            }
        }
        console.log(loginOs)
        this.setState({"loginOs": loginOs})
    }

    previousStep = () => {
        const {step} = this.state;
        this.setState({
            step: step - 1,
        })
    }

    render() {

        const {
            abnormalTime,
            step,
            showNoticeTip,
            seachprov,
            seachcity,
            seachdistrict,
            phone,
            account,
            inRoomShowGold,
            gamingShowGold,
            outRoomShowGold,
            stolenGold,
            gameList,
            abnormalRoomName,
            isPicUpload,
            selectedImages,
            picType,
            loginOs,
            loginNetwork,
            otherNetwork,
            content,
            isPropEx,
            phoneModels,
        } = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    {isPicUpload ?
                        <div className="sut_cont bggray">
                            <div className="phone_top pr">
                                <a className="xya_return" onClick={() => this.returnPage()}>
                                    <img src={require("../../../images/member/refund/return_icon.png")}/>
                                </a>
                                {picType === 1 && <div className="top_title">相关截图</div>}
                                {picType === 2 && <div className="top_title">操作系统（可多选）</div>}
                                {picType === 3 && <div className="top_title">网络使用情况</div>}
                            </div>
                            <div className="sut_box">
                                {picType === 1 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('pay')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{selectedImages.length}/5</p>
                                            </a>

                                        </div>
                                        {selectedImages.length > 0 && selectedImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 1)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/5</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {picType === 2 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <div className="radio_cont_kf clearfix">
                                                <label className="w135"><input type="checkbox" value="Windows"
                                                                               name="loginOs"
                                                                               checked={loginOs.indexOf("Windows") !== -1}
                                                                               onChange={() => this.setLoginOs()}/>Windows</label>
                                                <label className="w135"><input type="checkbox" value="xp" name="loginOs"
                                                                               checked={loginOs.indexOf("xp") !== -1}
                                                                               onChange={() => this.setLoginOs()}/>xp</label>
                                                <label className="w135"><input type="checkbox" value="安卓" name="loginOs"
                                                                               checked={loginOs.indexOf("安卓") !== -1}
                                                                               onChange={() => this.setLoginOs()}/>安卓</label>
                                                <label className="w135"><input type="checkbox" value="苹果" name="loginOs"
                                                                               checked={loginOs.indexOf("苹果") !== -1}
                                                                               onChange={() => this.setLoginOs()}/>苹果</label>
                                            </div>

                                        </div>
                                    </div>
                                }
                                {picType === 3 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <div className="radio_cont_kf clearfix">
                                                <label className="w135"><input type="radio" value="电信"
                                                                               name="loginNetwork"
                                                                               defaultChecked="true"
                                                                               checked={loginNetwork === '电信'}
                                                                               className="radio"
                                                                               onChange={() => this.setState({"loginNetwork": "电信"})}/>电信</label>
                                                <label className="w135"><input type="radio" value="联通"
                                                                               name="loginNetwork"
                                                                               className="radio"
                                                                               checked={loginNetwork === '联通'}
                                                                               onChange={() => this.setState({"loginNetwork": "联通"})}/>联通</label>
                                                <label className="w135"><input type="radio" value="移动"
                                                                               name="loginNetwork"
                                                                               className="radio"
                                                                               checked={loginNetwork === '移动'}
                                                                               onChange={() => this.setState({"loginNetwork": "移动"})}/>移动</label>
                                                <label className="w135"><input type="radio" value="其它"
                                                                               name="loginNetwork"
                                                                               className="radio"
                                                                               checked={loginNetwork === '其它'}
                                                                               onChange={() => this.setState({"loginNetwork": "其它"})}/>其它</label>
                                            </div>

                                        </div>
                                    </div>
                                }
                                <input id="upload_pay" type="file" onChange={e => this.handleFileInputChange(1, e)}
                                       className="file dn" accept="image/*" multiple/>
                            </div>
                        </div> :
                        <div className="sut_cont bggray">
                            <Script
                                url={captchaUrl()}
                                onError={this.handleScriptError}
                                onLoad={this.handleScriptLoad}
                            />
                            <div className="phone_top pr border-bottom-e6">
                                <div className="top_title">游戏异常</div>
                                <a onClick={() => this.previousStep()}
                                   className={step > 1 ? "previous_step" : 'dn'}>上一步</a>
                            </div>
                            <div className={step === 1 ? "cont_kf" : "dn"}>
                                <div className="point_tex">
                                    <p>同一账号24小时内仅能提交一次同类型异常问题。道具异常泛指游戏中使用的道具，如：游戏金币等</p>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w280"><em className="star">*</em> 游戏账号或ID</span>
                                    <input type="text" className="input-tex4" value={account}
                                           onChange={e => {
                                               this.setState({account: e.target.value})
                                           }}
                                           placeholder="第三方账号请填写游戏ID"/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span>* 游戏场次</span>
                                    <div className="login_area">
                                        <select name="problem" className="select_input2"
                                                onChange={e => this.getGameList(e.target.value)}>
                                            <option value="0">PC端</option>
                                            <option value="1">手游端</option>
                                        </select>
                                        <select name="problem" className="select_input2"
                                                onChange={e => this.setState({abnormalGameId: e.target.value})}>
                                            {gameList.map((item, index) => {
                                                return (
                                                    <option value={item.kindId}>{item.kindName}</option>
                                                )
                                            })}
                                        </select>
                                        <IonInput type="text" class="input-tex1"
                                                  value={abnormalRoomName}
                                                  onIonChange={e => this.setState({abnormalRoomName: e.detail.value})}
                                                  placeholder="请填写异常房间名"/>
                                    </div>
                                </div>
                                <div className="phone_upload clearfix pr">
                                    <span>是否道具异常</span>
                                    <div className="radio_cont_kf clearfix">
                                        <label className="w168"><input type="radio" value="1" name="msg" checked={isPropEx}
                                                                       onChange={() => this.setState({"isPropEx": true})}
                                                                       className="radio"/><em
                                            className="radio_em">是</em></label>
                                        <label className="w168"><input type="radio" value="0" name="msg" checked={!isPropEx}
                                                                       onChange={() => this.setState({"isPropEx": false})}
                                                                       defaultChecked='true'
                                                                       className="radio"/><em
                                            className="radio_em">否</em></label>
                                    </div>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w280">* 异常时间</span>
                                    <Datetime
                                        className={"dateForm-control"}
                                        input={true}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm:ss"
                                        value={abnormalTime}
                                        onChange={this.setAbnormalTime}
                                        onClose={this.validateTimeFormat}
                                    />
                                </div>
                                <div className={isPropEx ? "phone_identity clearfix" : 'dn'}>
                                    <span className="w280">* 进房间携带金币数</span>
                                    <input type="text" className="input-tex4" value={inRoomShowGold}
                                           onChange={e => {
                                               this.setState({inRoomShowGold: e.target.value})
                                           }}
                                           placeholder="填写进房间携带金币数 "/>
                                </div>
                                <div className={isPropEx ? "phone_identity clearfix" : 'dn'}>
                                    <span className="w280 fz14">* 游戏中显示金币数</span>
                                    <input type="text" className="input-tex4" value={gamingShowGold}
                                           onChange={e => {
                                               this.setState({gamingShowGold: e.target.value})
                                           }}
                                           placeholder="填写游戏中显示金币数 "/>
                                </div>
                                <div className={isPropEx ? "phone_identity clearfix" : 'dn'}>
                                    <span className="w280 fz14">* 出房间显示金币数</span>
                                    <input type="text" className="input-tex4" value={outRoomShowGold}
                                           onChange={e => {
                                               this.setState({outRoomShowGold: e.target.value})
                                           }}
                                           placeholder="填写出房间显示金币数"/>
                                </div>
                                <div className={isPropEx ? "phone_identity clearfix" : 'dn'}>
                                    <span className="w280 fz14">* 实际结算异常金币数</span>
                                    <input type="text" className="input-tex4" value={stolenGold}
                                           onChange={e => {
                                               this.setState({stolenGold: e.target.value})
                                           }}
                                           placeholder="填写实际结算异常金币数 "/>
                                </div>

                                <div className="phone_identity clearfix">
                                    <span className="w280 fz14">联系手机号码</span>
                                    <input type="text" className="input-tex4" value={phone}
                                           onChange={e => {
                                               this.setState({phone: e.target.value})
                                           }}
                                           placeholder="填写手机号码"/>
                                </div>
                                <a className="btn_kf mt100" onClick={this.nextStep}>下一步</a>
                                <div className="cont_tex_title"
                                     onClick={() => window.location = "/phone/accountTheft"}>账号被盗
                                </div>
                            </div>
                            <div className={step === 2 ? "cont_kf" : "dn"}>
                                <div className={isPropEx ? 'dn' : "clearfix pr phone_identity"}>
                                    <span className="w280 ml30">* 操作系统（可多选）</span>
                                    <a className="upload_icon1"><img
                                        src={require("../../../images/member/refund/jt_icon.png")}
                                        onClick={() => this.uploadPage(2)}/></a>
                                    <p className="upload_tex1 pa">{loginOs}</p>
                                </div>
                                <div className={isPropEx ? 'dn' : "clearfix pr phone_identity"}>
                                    <span className="w280 ml30">* 网络使用情况</span>
                                    <a className="upload_icon1"><img
                                        src={require("../../../images/member/refund/jt_icon.png")}
                                        onClick={() => this.uploadPage(3)}/></a>
                                    <p className="upload_tex1 pa">{loginNetwork}</p>

                                </div>
                                <div className="clearfix pr phone_identity">
                                    <span className="w280 ml30">游戏异常的相关截图</span>
                                    <a className="upload_icon1"><img
                                        src={require("../../../images/member/refund/jt_icon.png")}
                                        onClick={() => this.uploadPage(1)}/></a>
                                    {selectedImages.length > 0 && <p className="upload_tex1 pa">已上传</p>}
                                </div>
                                <div className={isPropEx ? 'dn' : "clearfix phone_identity"}>
                                    <span className="w280">* 常登录的地区</span>
                                    <div className="login_area">
                                        <center>
                                            <select id="seachprov" className="select_input1 w120 mr10" name="seachprov"
                                                    value={seachprov} onChange={e => {
                                                this.setState({seachprov: e.target.value})
                                            }}></select>
                                            <select id="seachcity" className="select_input1 w120 mr10" name="homecity"
                                                    value={seachcity} onChange={e => {
                                                this.setState({seachcity: e.target.value})
                                            }}></select>
                                            <select id="seachdistrict" className="select_input1 w120" name="homecity"
                                                    value={seachdistrict} onChange={e => {
                                                this.setState({seachdistrict: e.target.value})
                                            }}></select>
                                            <div className="clear"></div>
                                        </center>
                                    </div>
                                </div>
                                <div className="clearfix pr phone_identity bbn">
                                    <span className="w280 ml30">* 游戏异常说明</span>
                                    <textarea name="textarea" id="textarea"
                                              value={content}
                                              onChange={e => {
                                                  this.setState({content: e.target.value})
                                              }}
                                              className="textarea"
                                              placeholder={"提示：请尽可能描述您所发现的问题（如操作过程发生异常的情况等），至少输入10个汉字。"}> </textarea>
                                </div>
                                {/*<a className="btn_kf mt100" onClick={() => this.setState({step: 1})}>上一步</a>*/}
                                <a className="btn_kf mt100" onClick={() => this.submitMsg()}>提交</a>
                                <div className="cont_tex">
                                    <div className="cont_tex_title" onClick={this.showNotice}>处理流程</div>
                                    <p className={showNoticeTip ? "hidden_tex" : "dn"}>
                                        1、我们将在3个工作日（节假日顺延）内通过游戏邮件或短信告知您。<br/>
                                        2、如您的问题有助于平台优化产品，我们会给予奖励，感谢您的反馈。</p>
                                </div>
                            </div>
                            <div className={step === 3 ? "cont_kf" : "dn"}>
                                <div className="phone_instructions">
                                    <span>* 游戏异常说明</span>
                                    <textarea name="textarea" id="textarea"
                                              onChange={e => {
                                                  this.setState({content: e.target.value})
                                              }}
                                              className="textarea"
                                              placeholder={"提示：请尽可能描述您所发现的问题（如操作过程，发生异常的情况等，至少输入10个汉字） "}></textarea>
                                </div>
                                <a className="btn_kf mt100" onClick={() => this.setState({step: 2})}>上一步</a>
                                <a className="btn_kf mt100" onClick={this.submitMsg}>提交</a>
                                <div className="cont_tex">
                                    <div className="cont_tex_title">处理流程</div>
                                    <p className="hidden_tex dn">
                                        1、请您理解，为保护账号安全，我们可能会将您的账号给予临时冻结保护。<br/>
                                        2、我们将在3个工作日（节假日顺延）内通过游戏邮件或短信告知您核实结果。<br/>
                                        3、问题处理完毕后请您及时修改账号密码，如因原密码再次发生被盗，我们将不予再次受理。</p>
                                </div>
                            </div>
                        </div>
                    }
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(GameException);
